var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.7,
    height: 70.7,
    viewBox: "0 0 70.7 70.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.39,13.72a33.85,33.85,0,1,1-26-12.22V31",
    fill: "none",
    stroke: "#D163AB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.84,23.27a20.44,20.44,0,1,1-16.49-8.36",
    fill: "none",
    stroke: "#D163AB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.35,41.85a6.5,6.5,0,1,0-6.5-6.5A6.51,6.51,0,0,0,35.35,41.85Z",
    fill: "#D163AB",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.4d43ba104c6b807ccb8ca827ac344c9d.svg";
export { ForwardRef as ReactComponent };